import React, { useState } from "react";

const SmallScreenPopup = () => {
  const [isPopupVisible, setPopupVisible] = useState(true);

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  return (
    isPopupVisible && (
      <div className="fixed bg-white p-4 inset-0 flex flex-col items-center justify-center z-50">
        <p>
          This dashboard is best viewed on larger screens. Please use a larger
          screen for an optimal experience.
        </p>

        <button
          className="mt-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          onClick={handleClosePopup}
        >
          Close
        </button>
      </div>
    )
  );
};

export default SmallScreenPopup;
